import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarEvent } from 'core-lib';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-event-participants-overview',
    templateUrl: './event-participants-overview.component.html',
    styleUrl: './event-participants-overview.component.scss',
    standalone: false
})
export class EventParticipantsOverviewComponent implements OnInit {

  @Output() close = new EventEmitter<CalendarEvent>();
  @Input() context: {
    event: CalendarEvent;
    writePermission: boolean;
  }

  tabItems: MenuItem[] = [];
  activeTab: MenuItem;


  ngOnInit(): void {

    if (this.context.event.registrationRequired) {
      this.tabItems = [{ id: 'registrations', label: $localize`:@@event.participant.overview.registrations:Registrations`}, ...this.tabItems];
    }
    if (this.context.event.feedbackAllowed) {
      this.tabItems = [...this.tabItems, { id: 'feedback', label: $localize`:@@event.participant.overview.feedback:Participants feedback` }];
    }
    this.activeTab = this.tabItems[0];
  }
}
